import { unique, errorMessage } from "@totalsoft/pure-validations";
import { maximumInteger } from "constants/numericLimits";
import { getRandomInt } from "utils/functions";

export const subsidiesCollectionValidator =
  unique(x => (x.document.commissionId || '0') + (x.document.partnerId || getRandomInt(1, maximumInteger).toString()))
  |> errorMessage("OfferEdit.Subsidies.UniqueSubsidyForPartner");
